import React,{ useRef,useMemo,forwardRef } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import MOCK_DATA from '../jsx/components/table/FilteringTable/MOCK_DATA_2.json';
import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnsAtbaks';
 import { Link,useNavigate } from "react-router-dom";
 import axios from "axios";
 import swal from 'sweetalert'; 
import '../jsx/components/table/FilteringTable/filtering.css';
import { Col, Row ,Dropdown} from 'react-bootstrap';
import InviteCustomer1 from './SanadSaref';
import InviteCustomer from '../jsx/constant/EditWeddingHalls';
import { CSVLink } from 'react-csv';
import InviteCustomer31 from './Sanadqabd';
import { useReactToPrint } from "react-to-print";

import {useEffect, useState} from "react";

  const WeddingHall = forwardRef((props,ref) => {
	const columns = useMemo( () => COLUMNS, [] )
   const [data, setData] = useState([])
   const navigate = useNavigate();
   const [totalAmount, setTotalAmount] = useState(0);
   const componentRef = useRef()
  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Userdata",
   });
    const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
 const userPermissions = JSON.parse(userPermissionsJSON);
 function getActionsForPage(pageName) {
   const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
console.log('actionsForPage',pagePermissions); 
  if (pagePermissions) {
      return pagePermissions.action;
  } else {
 navigate('/dashboard_1')
     return [];
  }
}
const pageName = 'Garantees';
const actionsForPage = getActionsForPage(pageName);
    const [tabakName, setTabakName] = useState('');

const [fromDate, setFromDate] = useState('');
const [toDate, setToDate] = useState('');
const hasFilters = fromDate || toDate || tabakName;
    useEffect(() => {
  
 if (toDate || fromDate || tabakName ) {
      fetchProducts();
    }

   }, [fromDate,toDate,tabakName]);

 
const fetchProducts = async () => {
  try {
    const response = await axios.get('https://suhba.education.com.ly/back/api/getatback', {
      params: {
        from_date: fromDate,
        to_date: toDate,
                tabak_name: tabakName
      }
    });
    setData(response.data.data);
          setTotalAmount(response.data.total);

  } catch (error) {
    console.error(error);
  }
}

  
 const tableInstance = useTable({
		columns,
		data,	
		initialState : {pageIndex : 0}
	}, useFilters, useGlobalFilter, usePagination)
	
  const userdata = useRef();
  const invite = useRef();
  const invite1 = useRef();
	const { 
		getTableProps, 
		getTableBodyProps, 
		headerGroups, 
		prepareRow,
		state,
		page,
		gotoPage,
		pageCount,
		pageOptions,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		setGlobalFilter,
	} = tableInstance
    const {globalFilter, pageIndex} = state	
    //const navigate = useNavigate();
   
  
  
     
    return(
<>
<div className='container-fluid'>
				<Row>
					<Col lg="12">
						<div className="card">
            <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   

                 <div className="tbl-caption">
                 <h4 className="heading ms-3">مبيعات الاطباق</h4>
                <div>
                  <Link                     onClick={generatePDF}
 to="#" className="btn btn-secondary btn-sm ms-1" data-bs-toggle="offcanvas">
                    <i className="fa-solid fa-print ms-1" /> طباعه
                  </Link>

                </div>
                        </div>  
                   <div className="row g-2 align-items-center flex-nowrap mt-1 mb-3">

  {/* Tabak Name Input */}
  <div className="col-auto d-flex align-items-center">
    <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>اسم الطبق:</label>
    <input
      type="text"
      value={tabakName}
      onChange={(e) => setTabakName(e.target.value)}
      className="form-control"
      placeholder="اسم الطبق"
      style={{ minWidth: "140px" }}
    />
  </div>

  {/* From Date Input */}
  <div className="col-auto d-flex align-items-center">
    <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>من تاريخ:</label>
    <input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      className="form-control"
      style={{ minWidth: "140px" }}
    />
  </div>

  {/* To Date Input */}
  <div className="col-auto d-flex align-items-center">
    <label className="form-label mb-0 mx-2" style={{ whiteSpace: "nowrap" }}>إلى تاريخ:</label>
    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      className="form-control"
      style={{ minWidth: "140px" }}
    />
  </div>

  {/* Search Button */}
 

  {/* Clear Filters Button */}
  <div className="col-auto d-flex align-items-center">
    <button
      className="btn btn-sm btn-secondary mx-2"
      onClick={() => {
        setFromDate('');
        setToDate('');
        setTabakName('');
        setData([]); // optionally re-fetch full data
      }}
    >
      مسح الفلاتر
    </button>
  </div>

</div>

                        
               
</div>   </div> 
                        
                        		 
								<div className="table-responsive ">
									{/* <table ref={componentRef} {...getTableProps()} className="table dataTable rtl display table-hover">
									    {data.length > 0 && (
  <div className='col-12 row'
  style={{
    width:'100%',
    fontWeight: 'bold',
    fontSize: '18px',
    direction: 'rtl',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '10px'
  }}
>
  <label
    htmlFor="startMonth"
    style={{ fontSize: '15px', fontWeight: 'bold', color: 'blue', margin: 0 }}
  >
    اجمالي الدخل من مبيعات الاطباق   :
  </label>

  <div style={{ color: 'green' }}>
    <strong>{totalAmount.toLocaleString()} د.ل</strong>
  </div>
</div>   )}  
                  	<thead>
										{headerGroups.map(headerGroup => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        // Check if the column accessor is 'age' and render accordingly
                        column.id !== 'depositsID' ? (
                          <th {...column.getHeaderProps()}>
                            {column.render('Header')}
                            {column.canFilter ? column.render('Filter') : null}
                          </th>
                        ) : null
                      ))}
                        

                     </tr>
										
										))}
										</thead> 
                    <tbody {...getTableBodyProps()}>
{page.length > 0 ? (
  page.map((row) => {
    prepareRow(row);
    return (
      <tr {...row.getRowProps()}>
        {row.cells.map((cell) =>
          cell.column.id !== 'depositsID' ? (
            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
          ) : null
        )}
      </tr>
    );
  })
) : (
  <tr>
    <td colSpan={columns.length} className="text-center text-danger py-4">
      {!hasFilters ? ' لعرض البيانات، قم باستخدام الفلترة بالاسم أو بالتاريخ ❗' : 'لا توجد نتائج'}
    </td>
  </tr>
)}

                                    </tbody>
									</table> */}

<table ref={componentRef} {...getTableProps()} className="table dataTable rtl display table-hover">
  <thead>
    {headerGroups.map(headerGroup => (
      <tr {...headerGroup.getHeaderGroupProps()}>
        {headerGroup.headers.map((column) =>
          column.id !== 'depositsID' ? (
            <th {...column.getHeaderProps()}>
              {column.render('Header')}
              {column.canFilter ? column.render('Filter') : null}
            </th>
          ) : null
        )}
      </tr>
    ))}
  </thead>

  <tbody {...getTableBodyProps()}>
    {page.length > 0 ? (
      page.map((row) => {
        prepareRow(row);
        return (
          <tr {...row.getRowProps()}>
            {row.cells.map((cell) =>
              cell.column.id !== 'depositsID' ? (
                <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              ) : null
            )}
          </tr>
        );
      })
    ) : (
      <tr>
        <td colSpan={columns.length} className="text-center text-danger py-4">
          {!hasFilters
            ? ' لعرض البيانات، قم باستخدام الفلترة بالاسم أو بالتاريخ ❗'
            : 'لا توجد نتائج'}
        </td>
      </tr>
    )}
  </tbody>

  {data.length > 0 && (
    <tfoot>
      <tr>
        <td colSpan={columns.length} style={{ textAlign: 'right', fontWeight: 'bold', background: '#f8f9fa' }}>
          <span style={{ color: 'blue' }}>اجمالي الدخل من مبيعات الاطباق :</span>
          &nbsp;&nbsp;
          <span style={{ color: 'green' }}>{totalAmount.toLocaleString()} د.ل</span>
        </td>
      </tr>
    </tfoot>
  )}
</table>


									<div className="d-flex justify-content-between mx-2">
										<span>
											الصفحه{' '}
											<strong>
												{pageIndex + 1} من {pageOptions.length}
											</strong>{''}
										</span>
										<span className="table-index ">
											ادهب الى : {' '}
											<input type="number" 
												className="ml-2"
												defaultValue={pageIndex + 1} 
												onChange = {e => { 
													const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0 
													gotoPage(pageNumber)
												} } 
											/>
										</span>
									</div>
                                    <div className="text-center mb-3">  
                                        <div className="filter-pagination  mt-3">
                                            <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                                {/* {'<'} */}
                                                <i className='fa-solid fa-angle-right' />
                                            </button>
                                            
                                            <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                السابق
                                            </button>
                                            <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                                                التالي
                                            </button>
                                            <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                                                {/* {'>'} */}
                                                <i className='fa-solid fa-angle-left' />
                                            </button>
                                        </div>
                                    </div>
								</div>
						 
						</div>
					</Col>
				</Row>
			</div>
   
    
</>


    );
    });
export default WeddingHall;